const __DEV__ = false;

var data = { spacing:{ values:{ xs:"0.25rem",
      s:"0.5rem",
      m:"1rem",
      l:"1.5rem",
      xl:"2rem" },
    unit:"rem" } };

var spacing = data;

export { spacing as default };
//# sourceMappingURL=spacing.yaml.js.map
